import React from 'react'
import {
  Card,
  CardImg,
  CardBody,
  CardText,
  CardFooter,
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'

import {
  Link
} from 'react-router-dom'

export default class OmicsDatasetCard extends React.Component {
  constructor(props) {
    super(props)

    this.toggleDropdown = this.toggleDropdown.bind(this)

    this.state = {
      dropdownOpen: false,
      logo: null,
      banner: 'https://via.placeholder.com/326x120.webp'
    }
  }

  componentDidMount () {
    let dsLogo = null
    let dsBanner = null
    try {
      if (Modernizr.webp.alpha) {
        console.log(this.props.title.toLowerCase().replace(/ /g, '-').replace(/[^0-9a-zA-Z-_]/ig, ''))
        dsLogo = require(`../../assets/img/logos/${this.props.title.toLowerCase().replace(/ /g, '-').replace(/[^0-9a-zA-Z-_]/ig, '')}.webp`)
      } else {
        dsLogo = require(`../../assets/img/logos/${this.props.title.toLowerCase().replace(/ /g, '-').replace(/[^0-9a-zA-Z-_]/ig, '')}.png`)
      }
    } catch (e) {
      console.log('Cannot find logo')
    }
    try {
      if (Modernizr.webp.alpha) {
        if(this.props.title === undefined){
          dsBanner = require(`../../assets/img/logos/collection-card-all-banner.webp`)
        } else{
          dsBanner = require(`../../assets/img/logos/collection-card-all-banner.jpg`)
        }
        dsBanner = require(`../../assets/img/logos/${this.props.title.toLowerCase().replace(/ /g, '-').replace(/[^0-9a-zA-Z-_]/ig, '')}-banner.webp`)
      } else {
        dsBanner = require(`../../assets/img/logos/${this.props.title.toLowerCase().replace(/ /g, '-').replace(/[^0-9a-zA-Z-_]/ig, '')}-banner.jpg`)
      }
    } catch (e) {
      console.log('Cannot find banner')
    }
    this.setState({
      logo: dsLogo != null ? dsLogo:null,
      banner: dsBanner != null ? dsBanner: 'https://via.placeholder.com/326x120.webp'
    })
  
  }

  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    })
  }

  revealActions() {
    this.setState({
      showActions: !this.state.showActions
    })
  }

  render() {
    // let sponsors = this.props.funding !== undefined ? this.props.funding.split(',').map(source => require(`../assets/${source}.jpg`)) : []
    /* global Modernizr */
   
    return (
      <div className='dataset-card h-100'>
        
        <Card className='h-100'>
          
          {this.state.logo !== null && <div className='dataset-card-heading' style={{ backgroundImage: `url(${this.state.banner})` }}><div className='h-100 white-mask'><CardImg className='ds-logo' src={this.state.logo} alt='placeholder' /></div></div>}
          {this.state.logo === null && <div className='card-heading-text w-100' style={{ backgroundImage: `url(${this.state.banner})` }}><div className='white-mask'><h1 className='full-width w-100'>{this.props.title}</h1></div></div>}
          
          <CardBody className='text-left d-flex flex-column'>
            {/* <div className='w-100 mb-2'>
              <img className='card-banner-img' src={banner} alt='banner img' />
            </div> */}
            <CardText>{this.props.description}</CardText>
            <Link className='mt-auto' to={`/datasets/${this.props.did}/explore`}><Button className='w-100 align-bottom' color='info'>Browse All OMICs Datasets</Button></Link>
                        
          </CardBody>
          <CardFooter>
            <Row className='mb-2'>
              <Col md='12'>
                <div className='dataset-card-buttons'>
                  <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown}>
                    <DropdownToggle outline color='secondary' caret>
                      Viewing Options
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>
                        <Link to={`/datasets/${this.props.did}/explore`}>Browse All OMICs Datasets</Link>
                      </DropdownItem>
                    </DropdownMenu>
                  </ButtonDropdown>
                  <Link to={`/datasets/${this.props.did}/overview`}>
                    <Button outline>Collection  Details</Button>
                  </Link>
                </div>
              </Col>
            </Row>
          </CardFooter>
        </Card>
      </div>
    )
  }
}
